import { useCallback } from "react";

/**
 * The Root node id where the GDS popups appended to
 */
export var GdsPortalRootId = "gds-portal-root";
export var usePortalElement = function usePortalElement() {
  return useCallback(function () {
    var wrapper = document.querySelector("#".concat(GdsPortalRootId));
    if (!wrapper) {
      wrapper = document.createElement("div");
      wrapper.id = GdsPortalRootId;
      var portalRoot = document.body;
      portalRoot.appendChild(wrapper);
    }
    return wrapper;
  }, []);
};